module.exports = __webpack_public_path__ + "img/hero.7077f8cd.png";